<app-error-view>
  <div class="message-box" style="color: #fff">
    <p class="error-head">404</p>
    <p class="error-message">{{ "page_not_found" | translation }}</p>
    <div class="buttons-con">
      <div class="action-link-wrap">
        <a nbButton status="primary" (click)="back()">{{
          "back" | translation
        }}</a>
        <a nbButton outline status="primary" routerLink="/home">{{
          "home" | translation
        }}</a>
      </div>
    </div>
  </div>
</app-error-view>
